<template>
    <div class='main-layout'>
        <navbar id="navbar"></navbar>
        <sidebar id="sidebar"></sidebar>

        <transition name="fade" mode="out-in">
            <div class="main-layout__content">
                <router-view></router-view>
            </div>
        </transition>
    </div>
</template>

<script>
    import Navbar from 'Components/Navbar';
    import Sidebar from 'Components/Sidebar';

    export default {
        name: 'main-layout',
        components: {
            Navbar,
            Sidebar
        }
    }
</script>

<style rel='stylesheet/scss' lang='scss' scoped>
    @import '~@/styles/mixin';
    @import '~@/styles/layout';

    .main-layout {
        @include fullscreen;

        display               : grid;
        grid-template-rows    : $navbar-height auto;
        grid-template-columns : $sidebar-width auto;

        #navbar {
            grid-column : span 2;
        }

        #sidebar {

        }

        .main-layout__content {
            padding : 40px;
        }
    }
</style>